import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Microscope, TestTube, Activity, Brain, Server, CheckCircle, Globe, ArrowRight, Dna, Pill, Users, Laptop, Shield, HeartPulse, GraduationCap, FlaskConical } from 'lucide-react';
export function Research() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1966" data-mp="2sslxti1objxj">
      <Header data-id="element-1967" data-mp="3ghn4azqy4l06" />
      <main className="flex-grow" data-id="element-1968" data-mp="3gj81yy8k4k29">
        {/* Hero Section */}
        <section className="relative w-full bg-gray-50" data-id="element-1969" data-mp="3lhjdddei32ml">
          <div className="absolute inset-0 overflow-hidden" data-id="element-1970" data-mp="3lex5fcnp6l3u">
            <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
            backgroundBlendMode: 'overlay'
          }} data-id="element-1971" data-mp="36ipbvlqeg7bw" />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 to-blue-600/20" data-id="element-1972" data-mp="3f7qrhq6wnzwu" />
          </div>
          <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-1973" data-mp="3a9ytcefo3hk7">
            <div className="max-w-3xl" data-id="element-1974" data-mp="3o9gk2zcix4w7">
              <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-1975" data-mp="3j8shrhiuh1mo">
                Research at CalMiR
              </h1>
              <div className="w-20 h-1 bg-teal-600 mb-6" data-id="element-1976" data-mp="1zvv7fg76fl0"></div>
              <p className="text-lg md:text-xl text-gray-700 mb-8" data-id="element-1977" data-mp="3t6zxxy5b7fnm">
                Applying pharmaceutical-grade rigor to microbiome science,
                validating what works, debunking what doesn't, and ensuring
                global communities benefit from truth-driven health innovation.
              </p>
            </div>
          </div>
        </section>
        {/* Research Overview */}
        <section className="py-16 bg-white" data-id="element-1978" data-mp="fs3natwjdidd">
          <div className="container mx-auto px-4" data-id="element-1979" data-mp="ftepipac2i2d">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1980" data-mp="39k1xtaxz2mxt">
              <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-1981" data-mp="39lwiqp98uf1w">
                Our Research Approach
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-1982" data-mp="3djasqj4r0quy"></div>
              <p className="text-gray-600" data-id="element-1983" data-mp="3ijf825tx7fjl">
                CalMiR's research spans from basic science to global
                applications, creating a closed loop of discovery, validation,
                and adoption that separates real science from hype in the
                wellness industry.
              </p>
            </div>
          </div>
        </section>
        {/* Basic Science & Mechanistic Studies */}
        <section className="py-16 bg-gray-50" data-id="element-1984" data-mp="540rfd8onpo8">
          <div className="container mx-auto px-4" data-id="element-1985" data-mp="a3viphwdeh9t">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-1986" data-mp="a2kghmikphkt">
              <div className="md:w-1/3" data-id="element-1987" data-mp="26yrpql1c6wfl">
                <div className="sticky top-24" data-id="element-1988" data-mp="2bw1jgcvrdu98">
                  <div className="bg-teal-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-1989" data-mp="2bwtg7r13dy13">
                    <Microscope className="text-teal-600" size={32} data-id="element-1990" data-mp="24e3f0msfp9cv" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1991" data-mp="1zkr239x4aqzy">
                    Basic Science & Mechanistic Studies
                  </h2>
                  <div className="w-20 h-1 bg-teal-600 mb-6" data-id="element-1992" data-mp="1poe8sd5hif5q"></div>
                  <p className="text-gray-600" data-id="element-1993" data-mp="1pm1hvahr0ugj">
                    Investigating the fundamental interactions between microbes
                    and human biology to understand the mechanisms that drive
                    health outcomes.
                  </p>
                </div>
              </div>
              <div className="md:w-2/3 space-y-6" data-id="element-1994" data-mp="2dfb8mrk09m0m">
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-1995" data-mp="29b3jwudjs62e">
                  <div className="flex items-start" data-id="element-1996" data-mp="11zuyxt6sdubj">
                    <div className="bg-teal-50 p-3 rounded-full mr-4" data-id="element-1997" data-mp="xw6uvkhd5gv1">
                      <Dna className="text-teal-600" size={24} data-id="element-1998" data-mp="xz2r94dkbxhd" />
                    </div>
                    <div data-id="element-1999" data-mp="2lrbe57n45j6n">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2000" data-mp="2qjus45ppqgbz">
                        Host–Microbiome Interactions
                      </h3>
                      <p className="text-gray-600" data-id="element-2001" data-mp="2bx1lrpy68kvx">
                        We explore how bacteria, fungi, and biofilms interact
                        with human cells, studying the complex relationships
                        that influence health and disease states.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2002" data-mp="2vi60ec0d0is3">
                  <div className="flex items-start" data-id="element-2003" data-mp="2zjhw8z9tu08q">
                    <div className="bg-teal-50 p-3 rounded-full mr-4" data-id="element-2004" data-mp="1k4aln4ddac1e">
                      <TestTube className="text-teal-600" size={24} data-id="element-2005" data-mp="1k658io878e84" />
                    </div>
                    <div data-id="element-2006" data-mp="1o3jdg3oujzub">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2007" data-mp="1gluze2ahbo46">
                        Advanced Testing Models
                      </h3>
                      <p className="text-gray-600" data-id="element-2008" data-mp="1bmicxinisj24">
                        Our scientists use petri dish models, organoids, and 3D
                        gut simulations to test microbial activity in controlled
                        environments that mimic human physiology.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2009" data-mp="sxbt1sazpleq">
                  <div className="flex items-start" data-id="element-2010" data-mp="17m87c73n3uns">
                    <div className="bg-teal-50 p-3 rounded-full mr-4" data-id="element-2011" data-mp="12uq4telyxm0p">
                      <Dna className="text-teal-600" size={24} data-id="element-2012" data-mp="12sn6m7anwmkw" />
                    </div>
                    <div data-id="element-2013" data-mp="f3b23kqa52ox">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2014" data-mp="a62h7cdqykjz">
                        Biological Pathway Identification
                      </h3>
                      <p className="text-gray-600" data-id="element-2015" data-mp="ztopbn3v2uxz">
                        We identify key biological pathways—such as PKR,
                        mitochondrial stress, and barrier integrity—that link
                        microbiome changes to health outcomes across body
                        systems.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Applied Research */}
        <section className="py-16 bg-white" data-id="element-2016" data-mp="kx7f4z7ermd0">
          <div className="container mx-auto px-4" data-id="element-2017" data-mp="pwa83la4624m">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-2018" data-mp="pupebxvmin7t">
              <div className="md:w-1/3" data-id="element-2019" data-mp="uw4xtli5klo3">
                <div className="sticky top-24" data-id="element-2020" data-mp="ut0qwgdazbtq">
                  <div className="bg-blue-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2021" data-mp="21byzcouehnb8">
                    <FlaskConical className="text-blue-600" size={32} data-id="element-2022" data-mp="268z1ioo4q5x2" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2023" data-mp="3qqztwrgr9ks0">
                    Applied Research
                  </h2>
                  <div className="w-20 h-1 bg-blue-600 mb-6" data-id="element-2024" data-mp="3lvb1r972f65q"></div>
                  <p className="text-gray-600" data-id="element-2025" data-mp="3h16ueotw0w44">
                    Testing specific compounds and nutrients to understand their
                    effects on the microbiome and human health.
                  </p>
                </div>
              </div>
              <div className="md:w-2/3 space-y-6" data-id="element-2026" data-mp="332qgactp43by">
                <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2027" data-mp="3315imec3449v">
                  <div className="flex items-start" data-id="element-2028" data-mp="2y5q6prxn0ig3">
                    <div className="bg-blue-50 p-3 rounded-full mr-4" data-id="element-2029" data-mp="2t5cad75eewxw">
                      <Pill className="text-blue-600" size={24} data-id="element-2030" data-mp="wcait2sxphot" />
                    </div>
                    <div data-id="element-2031" data-mp="rd67o6mg99vu">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2032" data-mp="rcnzcbmij57k">
                        Candidate Compound Testing
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2033" data-mp="9wsyqa76653">
                        We systematically evaluate promising compounds for their
                        effects on microbiome health:
                      </p>
                      <ul className="text-gray-600 space-y-2 mb-4" data-id="element-2034" data-mp="3rmhqf7wllkn1">
                        <li className="flex items-start" data-id="element-2035" data-mp="3rkohtn2fcqce">
                          <span className="text-blue-600 mr-2" data-id="element-2036" data-mp="3dmgodp4lk75z">•</span>
                          <span data-id="element-2037" data-mp="3iltced77fka5">
                            <strong data-id="element-2038" data-mp="3im2znt0v7dc5">NAC (N-acetylcysteine)</strong> – Studying
                            its role in biofilm disruption and antioxidant
                            defense
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-2039" data-mp="38pq0ifmjw7a0">
                          <span className="text-blue-600 mr-2" data-id="element-2040" data-mp="12vq7o0r18ym1">•</span>
                          <span data-id="element-2041" data-mp="16wsbkuvw9yuc">
                            <strong data-id="element-2042" data-mp="16uz5pht3vine">Tomato phytonutrients</strong> –
                            Investigating antimicrobial and prebiotic effects
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-2043" data-mp="2neajxpsvdbxn">
                          <span className="text-blue-600 mr-2" data-id="element-2044" data-mp="314ns9t9oasni">•</span>
                          <span data-id="element-2045" data-mp="315yx7weuu6g7">
                            <strong data-id="element-2046" data-mp="2wd5qj2ztso1h">Spore-forming probiotics</strong> –
                            Examining colonization patterns and gut barrier
                            restoration
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2047" data-mp="3k273n3jlsnd3">
                  <div className="flex items-start" data-id="element-2048" data-mp="3f22mdbavfolt">
                    <div className="bg-blue-50 p-3 rounded-full mr-4" data-id="element-2049" data-mp="1pq0f731p8a2u">
                      <Activity className="text-blue-600" size={24} data-id="element-2050" data-mp="1kqe34wxlwzvm" />
                    </div>
                    <div data-id="element-2051" data-mp="hh2k1resva56">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2052" data-mp="hidjjf17pvqh">
                        Nutrient Cofactor Research
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2053" data-mp="ckkcykvzyzpo">
                        Our research examines how essential nutrients influence
                        microbiome balance and systemic wellness:
                      </p>
                      <div className="grid md:grid-cols-2 gap-4" data-id="element-2054" data-mp="108buq40b44yc">
                        <div className="bg-white p-3 rounded-lg" data-id="element-2055" data-mp="109muztujmukp">
                          <p className="font-medium text-gray-800" data-id="element-2056" data-mp="w6qimkvljup7">
                            B Vitamins
                          </p>
                          <p className="text-sm text-gray-600" data-id="element-2057" data-mp="mgf4k5i7854l">
                            Microbial metabolism support
                          </p>
                        </div>
                        <div className="bg-white p-3 rounded-lg" data-id="element-2058" data-mp="1jxw0f5l3kx25">
                          <p className="font-medium text-gray-800" data-id="element-2059" data-mp="1f4ay51ch1gx5">Selenium</p>
                          <p className="text-sm text-gray-600" data-id="element-2060" data-mp="1mh0qz2583oxt">
                            Antioxidant pathways
                          </p>
                        </div>
                        <div className="bg-white p-3 rounded-lg" data-id="element-2061" data-mp="1weew45lp4rat">
                          <p className="font-medium text-gray-800" data-id="element-2062" data-mp="1wd3ply0v95g0">Magnesium</p>
                          <p className="text-sm text-gray-600" data-id="element-2063" data-mp="20grxkhteu31s">
                            Cellular energy production
                          </p>
                        </div>
                        <div className="bg-white p-3 rounded-lg" data-id="element-2064" data-mp="2adejzb1dx25x">
                          <p className="font-medium text-gray-800" data-id="element-2065" data-mp="2f4wkjxzhx0qd">Choline</p>
                          <p className="text-sm text-gray-600" data-id="element-2066" data-mp="2f6zkb9qga88a">
                            Membrane integrity
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Clinical & Translational Research */}
        <section className="py-16 bg-gray-50" data-id="element-2067" data-mp="t2xzh7ub82py">
          <div className="container mx-auto px-4" data-id="element-2068" data-mp="p1338hr8kfj1">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-2069" data-mp="p2e68fcuxj93">
              <div className="md:w-1/3" data-id="element-2070" data-mp="12t9gnw3088es">
                <div className="sticky top-24" data-id="element-2071" data-mp="12uaug8ben907">
                  <div className="bg-emerald-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2072" data-mp="y198xhgp0b7n">
                    <Users className="text-emerald-600" size={32} data-id="element-2073" data-mp="1cp2pb4dlrhra" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2074" data-mp="17q9e5ilsg2ua">
                    Clinical & Translational Research
                  </h2>
                  <div className="w-20 h-1 bg-emerald-600 mb-6" data-id="element-2075" data-mp="1loptfxxpv1o1"></div>
                  <p className="text-gray-600" data-id="element-2076" data-mp="1gsioo8h23w7o">
                    Moving from laboratory discoveries to human trials,
                    validating the efficacy of microbiome interventions in
                    real-world settings.
                  </p>
                </div>
              </div>
              <div className="md:w-2/3 space-y-6" data-id="element-2077" data-mp="1y1uxokr6w741">
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2078" data-mp="230xs7b9jmuxr">
                  <div className="flex items-start" data-id="element-2079" data-mp="1p9sz6s0ol0we">
                    <div className="bg-emerald-50 p-3 rounded-full mr-4" data-id="element-2080" data-mp="1p76ssvpj0rfr">
                      <HeartPulse className="text-emerald-600" size={24} data-id="element-2081" data-mp="1t91q7p4c6ko9" />
                    </div>
                    <div data-id="element-2082" data-mp="1f98xjo991udn">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2083" data-mp="1fd6fi6k3cfvy">
                        Human Clinical Trials
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2084" data-mp="16b6y3d55z9sh">
                        Our clinical research program follows a systematic
                        approach:
                      </p>
                      <ol className="text-gray-600 space-y-4 mb-4" data-id="element-2085" data-mp="30p7w5vsw3sri">
                        <li className="flex items-start" data-id="element-2086" data-mp="34pi0z54y4d4s">
                          <span className="bg-emerald-100 text-emerald-800 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-2087" data-mp="34oyuckkqxb62">
                            1
                          </span>
                          <div data-id="element-2088" data-mp="2axy33abec4ae">
                            <p className="font-medium" data-id="element-2089" data-mp="260o9rjkvz8ha">Pilot Trials</p>
                            <p className="text-sm" data-id="element-2090" data-mp="262r6snkgi1vi">
                              Small-scale studies (30–60 participants) testing
                              microbiota reset protocols and establishing safety
                              profiles
                            </p>
                          </div>
                        </li>
                        <li className="flex items-start" data-id="element-2091" data-mp="1n9nb6wnohey9">
                          <span className="bg-emerald-100 text-emerald-800 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-2092" data-mp="1n83skzejurtb">
                            2
                          </span>
                          <div data-id="element-2093" data-mp="19anjfg4vcjxv">
                            <p className="font-medium" data-id="element-2094" data-mp="19bqbhrdxgsfd">
                              Expanded Clinical Studies
                            </p>
                            <p className="text-sm" data-id="element-2095" data-mp="3l03ih0nfxh0m">
                              Larger trials (100–300 participants) with genomic
                              and microbiome stratification to identify
                              responder profiles
                            </p>
                          </div>
                        </li>
                        <li className="flex items-start" data-id="element-2096" data-mp="31at3jovir03k">
                          <span className="bg-emerald-100 text-emerald-800 w-6 h-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-2097" data-mp="3186wrrggcome">
                            3
                          </span>
                          <div data-id="element-2098" data-mp="3fyxq53xozvrm">
                            <p className="font-medium" data-id="element-2099" data-mp="3fz7k12luyn2l">Protocol Refinement</p>
                            <p className="text-sm" data-id="element-2100" data-mp="2ijtobfdtt4nh">
                              Iterative improvement of interventions based on
                              clinical outcomes and patient feedback
                            </p>
                          </div>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2101" data-mp="2p7qr9tpdm8td">
                  <div className="flex items-start" data-id="element-2102" data-mp="2k85heo8o4g1v">
                    <div className="bg-emerald-50 p-3 rounded-full mr-4" data-id="element-2103" data-mp="2k9fgngr9bua3">
                      <Brain className="text-emerald-600" size={24} data-id="element-2104" data-mp="1wjullzhtx6kg" />
                    </div>
                    <div data-id="element-2105" data-mp="1sij2mctgnjl8">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2106" data-mp="1sjap8y52y6zd">
                        Focus Areas
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2107" data-mp="21ifn028thwah">
                        Our clinical research focuses on conditions where
                        microbiome interventions show particular promise:
                      </p>
                      <div className="grid md:grid-cols-2 gap-4" data-id="element-2108" data-mp="3cw9rrn26phaw">
                        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2109" data-mp="yptmsn874s7d">
                          <h4 className="font-medium text-gray-800 mb-1" data-id="element-2110" data-mp="yroauaerl0fo">
                            Autism & Neurodevelopmental Disorders
                          </h4>
                          <p className="text-sm text-gray-600" data-id="element-2111" data-mp="pq6typtj8upx">
                            Exploring gut-brain connections and microbial
                            influences on neurological development
                          </p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2112" data-mp="1mfnzn4simgrm">
                          <h4 className="font-medium text-gray-800 mb-1" data-id="element-2113" data-mp="1mgz3t5pvhqj9">
                            IBS & Digestive Health
                          </h4>
                          <p className="text-sm text-gray-600" data-id="element-2114" data-mp="1dljduzs8nviy">
                            Developing targeted interventions for common
                            digestive conditions
                          </p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2115" data-mp="264ygwn7wt9ru">
                          <h4 className="font-medium text-gray-800 mb-1" data-id="element-2116" data-mp="62gpcudwpdrd">
                            Chronic Fatigue & Long COVID
                          </h4>
                          <p className="text-sm text-gray-600" data-id="element-2117" data-mp="3sfxawdm00gfa">
                            Investigating microbiome's role in post-viral and
                            fatigue syndromes
                          </p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2118" data-mp="oyyohwv34fxn">
                          <h4 className="font-medium text-gray-800 mb-1" data-id="element-2119" data-mp="k1otm1oxfc2f">
                            Metabolic & Autoimmune Conditions
                          </h4>
                          <p className="text-sm text-gray-600" data-id="element-2120" data-mp="b08reh89mg9a">
                            Studying microbial influences on immune regulation
                            and metabolic health
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Computational & AI-Driven Research */}
        <section className="py-16 bg-white" data-id="element-2121" data-mp="1f7o2opmb6t8x">
          <div className="container mx-auto px-4" data-id="element-2122" data-mp="1k8buhdid3e47">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-2123" data-mp="1k6qv9al3r700">
              <div className="md:w-1/3" data-id="element-2124" data-mp="1p0buf5yfm70s">
                <div className="sticky top-24" data-id="element-2125" data-mp="1tyn7rqnxqznr">
                  <div className="bg-indigo-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2126" data-mp="1txva8aas2ruu">
                    <Server className="text-indigo-600" size={32} data-id="element-2127" data-mp="1yw6nkv0a7kht" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2128" data-mp="22zust71fy3zw">
                    Computational & AI-Driven Research
                  </h2>
                  <div className="w-20 h-1 bg-indigo-600 mb-6" data-id="element-2129" data-mp="8lk2sv9413sj"></div>
                  <p className="text-gray-600" data-id="element-2130" data-mp="8nequifohc0u">
                    Leveraging advanced computational methods to analyze complex
                    microbiome data and develop personalized therapeutic
                    approaches.
                  </p>
                </div>
              </div>
              <div className="md:w-2/3 space-y-6" data-id="element-2131" data-mp="2d1a38k353on">
                <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2132" data-mp="7bktb17ao1db">
                  <div className="flex items-start" data-id="element-2133" data-mp="c3cndlpnsp87">
                    <div className="bg-indigo-50 p-3 rounded-full mr-4" data-id="element-2134" data-mp="g46a4brd7xzi">
                      <Laptop className="text-indigo-600" size={24} data-id="element-2135" data-mp="g68yysgs7l2n" />
                    </div>
                    <div data-id="element-2136" data-mp="l1el9se3j1r9">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2137" data-mp="q2cagoxiww29">
                        Bioinformatics & Data Analysis
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2138" data-mp="v0x23zypm7f3">
                        We apply sophisticated computational techniques to
                        extract meaningful insights from complex microbiome
                        data:
                      </p>
                      <ul className="text-gray-600 space-y-2 mb-4" data-id="element-2139" data-mp="1dy767g9m5y8w">
                        <li className="flex items-start" data-id="element-2140" data-mp="1dziadh6z180j">
                          <span className="text-indigo-600 mr-2" data-id="element-2141" data-mp="1965rzosvxxg8">•</span>
                          <span data-id="element-2142" data-mp="154ki8cbndza9">
                            Analysis of 16S rRNA and metagenomic sequencing data
                            to identify microbial signatures
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-2143" data-mp="1wvqlv2qkuf4a">
                          <span className="text-indigo-600 mr-2" data-id="element-2144" data-mp="1suokaf96tqz5">•</span>
                          <span data-id="element-2145" data-mp="1nvv3odyltjur">
                            Development of AI models to predict therapeutic
                            outcomes based on baseline microbiome profiles
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-2146" data-mp="chhl9ommdwm4">
                          <span className="text-indigo-600 mr-2" data-id="element-2147" data-mp="7hv81f6skgdb">•</span>
                          <span data-id="element-2148" data-mp="7joi74gm5iq2">
                            Pattern recognition across large datasets to
                            identify previously unrecognized correlations
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2149" data-mp="4wnsn1x921ei">
                  <div className="flex items-start" data-id="element-2150" data-mp="3mcm5mvv8kquy">
                    <div className="bg-indigo-50 p-3 rounded-full mr-4" data-id="element-2151" data-mp="3mbu6xc6ced0g">
                      <Dna className="text-indigo-600" size={24} data-id="element-2152" data-mp="3r5opgca7olxy" />
                    </div>
                    <div data-id="element-2153" data-mp="3dejx7v96avxn">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2154" data-mp="3db5tojorwgom">
                        Personalized Protocol Development
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2155" data-mp="33g45pr68hknm">
                        Our computational research enables truly personalized
                        approaches by integrating multiple data types:
                      </p>
                      <div className="relative overflow-hidden" data-id="element-2156" data-mp="2ou6uef3922xh">
                        <div className="bg-indigo-50 p-4 rounded-lg" data-id="element-2157" data-mp="2juayl34phht0">
                          <h4 className="font-medium text-gray-800 mb-3" data-id="element-2158" data-mp="2yqtcwx83shwc">
                            Integrated Data Analysis
                          </h4>
                          <div className="grid grid-cols-3 gap-3" data-id="element-2159" data-mp="2tta081r20d6i">
                            <div className="bg-white p-3 rounded-lg text-center" data-id="element-2160" data-mp="37png56fxw6iv">
                              <p className="font-medium text-indigo-700" data-id="element-2161" data-mp="32sn8ws7csxq6">
                                Genetic SNPs
                              </p>
                              <p className="text-xs text-gray-600 mt-1" data-id="element-2162" data-mp="3him5iqj9g13j">
                                Individual genetic variations
                              </p>
                            </div>
                            <div className="bg-white p-3 rounded-lg text-center" data-id="element-2163" data-mp="3qf3gntrmjyza">
                              <p className="font-medium text-indigo-700" data-id="element-2164" data-mp="3mhp8m5fojx8v">
                                Microbiome Profiles
                              </p>
                              <p className="text-xs text-gray-600 mt-1" data-id="element-2165" data-mp="1oril37add63r">
                                Microbial community composition
                              </p>
                            </div>
                            <div className="bg-white p-3 rounded-lg text-center" data-id="element-2166" data-mp="1yh22s9mcitx1">
                              <p className="font-medium text-indigo-700" data-id="element-2167" data-mp="10uv0j6dildnu">
                                Biomarker Levels
                              </p>
                              <p className="text-xs text-gray-600 mt-1" data-id="element-2168" data-mp="15viotkaczged">
                                Metabolic and inflammatory markers
                              </p>
                            </div>
                          </div>
                          <div className="flex justify-center mt-4" data-id="element-2169" data-mp="2m87i8nodjk6t">
                            <div className="bg-indigo-100 p-2 rounded-lg w-10 flex justify-center" data-id="element-2170" data-mp="2ma0mjwbilsbn">
                              <ArrowRight className="text-indigo-600" size={20} data-id="element-2171" data-mp="2qb418fhttiba" />
                            </div>
                          </div>
                          <div className="bg-white p-3 rounded-lg text-center mt-4" data-id="element-2172" data-mp="5st1mekqfdp3">
                            <p className="font-medium text-indigo-700" data-id="element-2173" data-mp="v185g4fvjis">
                              Personalized Intervention Protocol
                            </p>
                            <p className="text-xs text-gray-600 mt-1" data-id="element-2174" data-mp="3ryg5t8eu13ea">
                              Tailored to individual biological profile
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Certification & Validation Research */}
        <section className="py-16 bg-gray-50" data-id="element-2175" data-mp="1caprlxihi0eu">
          <div className="container mx-auto px-4" data-id="element-2176" data-mp="1c7tycmhkzzwq">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-2177" data-mp="1vdhwioh6m78z">
              <div className="md:w-1/3" data-id="element-2178" data-mp="205jjb4bz7gd9">
                <div className="sticky top-24" data-id="element-2179" data-mp="206kvjc4qa8wk">
                  <div className="bg-amber-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2180" data-mp="1mdv2inqs83py">
                    <CheckCircle className="text-amber-600" size={32} data-id="element-2181" data-mp="1rbwq9lz5kr7r" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2182" data-mp="2f20r5lkyicv2">
                    Certification & Validation Research
                  </h2>
                  <div className="w-20 h-1 bg-amber-600 mb-6" data-id="element-2183" data-mp="2j1ro6712tp81"></div>
                  <p className="text-gray-600" data-id="element-2184" data-mp="253b6jl1oeeb4">
                    Establishing rigorous standards for supplement quality and
                    efficacy through our Ukweli Certified™ program.
                  </p>
                </div>
              </div>
              <div className="md:w-2/3 space-y-6" data-id="element-2185" data-mp="ynr36skmmq4r">
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2186" data-mp="yplnq5rzkg8b">
                  <div className="flex items-start" data-id="element-2187" data-mp="r6m6o6rzz0s4">
                    <div className="bg-amber-50 p-3 rounded-full mr-4" data-id="element-2188" data-mp="m67wai2xbeqx">
                      <Shield className="text-amber-600" size={24} data-id="element-2189" data-mp="104xu5zxkhigc" />
                    </div>
                    <div data-id="element-2190" data-mp="v63cj1bc5zxt">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2191" data-mp="v5uyv77e2qlk">
                        Ukweli Certified™ Program
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2192" data-mp="7efvdb3vm38q">
                        Our certification program establishes a three-tier
                        evidence framework for microbiome supplements:
                      </p>
                      <div className="space-y-4 mb-4" data-id="element-2193" data-mp="cfve2wikzxny">
                        <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-500" data-id="element-2194" data-mp="cealvdjqoqt9">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-2195" data-mp="3ktlx669fkdq9">
                            Level 1: Purity & Safety
                          </h4>
                          <p className="text-gray-600" data-id="element-2196" data-mp="2vba7jhm6o5q3">
                            Analytical chemistry testing to verify ingredient
                            quality, absence of contaminants, and label accuracy
                          </p>
                        </div>
                        <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-500" data-id="element-2197" data-mp="39a9xcslfmqnu">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-2198" data-mp="3e9cora8hoydc">
                            Level 2: Mechanistic Plausibility
                          </h4>
                          <p className="text-gray-600" data-id="element-2199" data-mp="3i952e1cqpupk">
                            Laboratory studies and biomarker research
                            demonstrating biological mechanisms of action
                          </p>
                        </div>
                        <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-500" data-id="element-2200" data-mp="v9dglwciob7">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-2201" data-mp="5t1d6238fepy">
                            Level 3: Clinical Efficacy
                          </h4>
                          <p className="text-gray-600" data-id="element-2202" data-mp="1q9itkqh8j4ox">
                            Human trials confirming real-world effectiveness and
                            validating health outcome claims
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2203" data-mp="2911riiwejsk3">
                  <div className="flex items-start" data-id="element-2204" data-mp="244bg48vjll50">
                    <div className="bg-amber-50 p-3 rounded-full mr-4" data-id="element-2205" data-mp="1zc0ff3sz9vbe">
                      <Activity className="text-amber-600" size={24} data-id="element-2206" data-mp="1za78dnegd92v" />
                    </div>
                    <div data-id="element-2207" data-mp="1ub49ylsza13v">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2208" data-mp="2rsb3qzxk4vfd">
                        Benchmark Standards Development
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2209" data-mp="2n0jkzbkn7tzs">
                        We're establishing transparent, reproducible standards
                        for evaluating supplements and probiotics:
                      </p>
                      <ul className="text-gray-600 space-y-2 mb-4" data-id="element-2210" data-mp="1m20989kcgyw">
                        <li className="flex items-start" data-id="element-2211" data-mp="1nd4f96x7qqj">
                          <span className="text-amber-600 mr-2" data-id="element-2212" data-mp="3tpl1jadeysfo">•</span>
                          <span data-id="element-2213" data-mp="bk81dnnjpj2p">
                            Standardized testing protocols that can be
                            independently verified
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-2214" data-mp="laj6hdiytyb6">
                          <span className="text-amber-600 mr-2" data-id="element-2215" data-mp="lc3zuztjnb7g">•</span>
                          <span data-id="element-2216" data-mp="gc99cxdoknmx">
                            Comparative analysis of similar products to identify
                            best-in-class formulations
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-2217" data-mp="p9jo4sppiuwl">
                          <span className="text-amber-600 mr-2" data-id="element-2218" data-mp="18yg2pt03549j">•</span>
                          <span data-id="element-2219" data-mp="1dx12xsfc7nxz">
                            Publication of methodology and results to advance
                            industry standards
                          </span>
                        </li>
                      </ul>
                      <a href="/certification" className="inline-flex items-center text-amber-600 hover:text-amber-700 transition-colors duration-200 font-medium" data-id="element-2220" data-mp="13wqoy5lhachr">
                        Learn more about our certification process
                        <ArrowRight size={16} className="ml-1" data-id="element-2221" data-mp="gak7ksq5zkev" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Global & Translational Health Research */}
        <section className="py-16 bg-white" data-id="element-2222" data-mp="c5uc34zf47uh">
          <div className="container mx-auto px-4" data-id="element-2223" data-mp="2dwb9vrzk0bk9">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-2224" data-mp="2dx37t9gmildp">
              <div className="md:w-1/3" data-id="element-2225" data-mp="29533l4tit6bb">
                <div className="sticky top-24" data-id="element-2226" data-mp="294a14g1lh2yz">
                  <div className="bg-purple-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2227" data-mp="246056381pycb">
                    <Globe className="text-purple-600" size={32} data-id="element-2228" data-mp="205pre4e0i3mw" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2229" data-mp="2wvfgyv7jbv9a">
                    Global & Translational Health Research
                  </h2>
                  <div className="w-20 h-1 bg-purple-600 mb-6" data-id="element-2230" data-mp="2rtzssua298mo"></div>
                  <p className="text-gray-600" data-id="element-2231" data-mp="2nt64w0wmbtts">
                    Extending the benefits of microbiome science to underserved
                    communities worldwide through our{' '}
                    <a href="/about/afya-program" className="text-purple-600 hover:text-purple-700" data-id="element-2232" data-mp="1cgdg8yz4jlhy">
                      Afya Program
                    </a>
                    .
                  </p>
                </div>
              </div>
              <div className="md:w-2/3 space-y-6" data-id="element-2233" data-mp="3o3h2ekqsoyei">
                <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2234" data-mp="3s4apxd0bsb6v">
                  <div className="flex items-start" data-id="element-2235" data-mp="q4zvbb67ntp">
                    <div className="bg-purple-50 p-3 rounded-full mr-4" data-id="element-2236" data-mp="rps2ua0iuoe">
                      <Globe className="text-purple-600" size={24} data-id="element-2237" data-mp="5nwp1xkfkvu7" />
                    </div>
                    <div data-id="element-2238" data-mp="amhq1z7ibjjp">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2239" data-mp="alya2o1f358b">
                        <a href="/about/afya-program" className="hover:text-purple-600 transition-colors" data-id="element-2240" data-mp="fo71vh2k018u">
                          Afya Program Initiatives
                        </a>
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2241" data-mp="2lgvlvhprrbyu">
                        Our global health research focuses on adapting
                        evidence-based approaches for diverse settings:
                      </p>
                      <ul className="text-gray-600 space-y-2 mb-4" data-id="element-2242" data-mp="1m3ss65wxgk1z">
                        <li className="flex items-start" data-id="element-2243" data-mp="202sgtdkfwyy5">
                          <span className="text-purple-600 mr-2" data-id="element-2244" data-mp="1v4qvelzjknji">•</span>
                          <span data-id="element-2245" data-mp="1v5jy9bvdqswd">
                            Adapting microbiome protocols for regions with
                            limited healthcare infrastructure
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-2246" data-mp="1h4pk0clnhxps">
                          <span className="text-purple-600 mr-2" data-id="element-2247" data-mp="1h6aey3bvnio6">•</span>
                          <span data-id="element-2248" data-mp="1cd7tkih97fj2">
                            Developing low-cost diagnostics and simplified
                            microbiome testing kits
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-2249" data-mp="jp279rajxih4">
                          <span className="text-purple-600 mr-2" data-id="element-2250" data-mp="2vcf6k026581y">•</span>
                          <span data-id="element-2251" data-mp="303nh4zf8izgp">
                            Researching locally available foods and traditional
                            practices with beneficial microbiome effects
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2252" data-mp="3e4hrvopr9cij">
                  <div className="flex items-start" data-id="element-2253" data-mp="3j1zs8qppijex">
                    <div className="bg-purple-50 p-3 rounded-full mr-4" data-id="element-2254" data-mp="3530ck8k69euw">
                      <GraduationCap className="text-purple-600" size={24} data-id="element-2255" data-mp="355326rhex5z3" />
                    </div>
                    <div data-id="element-2256" data-mp="3a3o6b1zsc9st">
                      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-2257" data-mp="1tn21jz5foir1">
                        Knowledge Transfer & Capacity Building
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-2258" data-mp="1ykblx0dyu480">
                        We're committed to sharing expertise and building local
                        capacity:
                      </p>
                      <div className="grid md:grid-cols-2 gap-4" data-id="element-2259" data-mp="3vetzmbzt3c36">
                        <div className="bg-white p-4 rounded-lg" data-id="element-2260" data-mp="3qkps9rmmp21k">
                          <h4 className="font-medium text-gray-800 mb-1" data-id="element-2261" data-mp="3mkyxzdxw83sa">
                            Clinician Training
                          </h4>
                          <p className="text-sm text-gray-600" data-id="element-2262" data-mp="3hmnnr23orr9j">
                            Educational programs for healthcare providers on
                            microbiome science
                          </p>
                        </div>
                        <div className="bg-white p-4 rounded-lg" data-id="element-2263" data-mp="33m31tx2h5fbt">
                          <h4 className="font-medium text-gray-800 mb-1" data-id="element-2264" data-mp="33nxobfte9fi0">
                            NGO Partnerships
                          </h4>
                          <p className="text-sm text-gray-600" data-id="element-2265" data-mp="11v9kb48xeo16">
                            Collaborations with organizations already working in
                            underserved regions
                          </p>
                        </div>
                        <div className="bg-white p-4 rounded-lg" data-id="element-2266" data-mp="2ool72vosfyof">
                          <h4 className="font-medium text-gray-800 mb-1" data-id="element-2267" data-mp="2ti668r24ayp7">
                            Implementation Research
                          </h4>
                          <p className="text-sm text-gray-600" data-id="element-2268" data-mp="20tigai6fbl5b">
                            Studying how to effectively deploy interventions in
                            diverse settings
                          </p>
                        </div>
                        <div className="bg-white p-4 rounded-lg" data-id="element-2269" data-mp="29sc87v8t7ncj">
                          <h4 className="font-medium text-gray-800 mb-1" data-id="element-2270" data-mp="2ett8ppndt7sl">
                            Resource Development
                          </h4>
                          <p className="text-sm text-gray-600" data-id="element-2271" data-mp="3lb6ka1uozo92">
                            Creating adaptable educational materials in multiple
                            languages
                          </p>
                        </div>
                      </div>
                      <div className="mt-4" data-id="element-2272" data-mp="2wxtlp3oqe20d">
                        <a href="/about/afya-program" className="inline-flex items-center text-purple-600 hover:text-purple-700 transition-colors duration-200 font-medium" data-id="element-2273" data-mp="3anevbngn54vq">
                          Learn more about the Afya Program
                          <ArrowRight size={16} className="ml-1" data-id="element-2274" data-mp="3fn9mzt88pyhu" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Research Summary */}
        <section className="py-16 bg-gray-50" data-id="element-2275" data-mp="1z88a288tjca8">
          <div className="container mx-auto px-4" data-id="element-2276" data-mp="1z9077ni2di2m">
            <div className="max-w-4xl mx-auto" data-id="element-2277" data-mp="1v76dy0a77gch">
              <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-2278" data-mp="1v8hhbyzqem32">
                Our Research Ecosystem
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-8" data-id="element-2279" data-mp="1p4jrcu4l40yt"></div>
              <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-2280" data-mp="1p6nw1eab5405">
                <p className="text-gray-700 text-lg mb-6 italic" data-id="element-2281" data-mp="1bc3jng0qnerk">
                  "In short, CalMiR's research spans bench science → applied
                  testing → clinical trials → certification → global
                  application. It's designed to create a closed loop of
                  discovery, validation, and adoption that separates real
                  science from hype in the $120B+ wellness industry."
                </p>
                <div className="relative py-8" data-id="element-2282" data-mp="sgnb5qd277o4">
                  {/* Connector Line */}
                  <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200 transform -translate-y-1/2 z-0" data-id="element-2283" data-mp="xfhuctexuy8r"></div>
                  {/* Research Pipeline Steps */}
                  <div className="grid grid-cols-5 relative z-10" data-id="element-2284" data-mp="2rq3h8kc42sbn">
                    <div className="flex flex-col items-center" data-id="element-2285" data-mp="r2ay1ysvnnio">
                      <div className="bg-teal-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-3" data-id="element-2286" data-mp="r0zyycadn3xw">
                        <Microscope className="text-teal-600" size={20} data-id="element-2287" data-mp="i2ehkkgn5uyp" />
                      </div>
                      <p className="text-center text-sm font-medium text-gray-700" data-id="element-2288" data-mp="m3g90f4bh2q4">
                        Bench Science
                      </p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-2289" data-mp="8ai7sc570gen">
                      <div className="bg-blue-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-3" data-id="element-2290" data-mp="d3thcl1e3ba9">
                        <FlaskConical className="text-blue-600" size={20} data-id="element-2291" data-mp="3ulcoi3hs3ho1" />
                      </div>
                      <p className="text-center text-sm font-medium text-gray-700" data-id="element-2292" data-mp="3b5m3uq25fdn">
                        Applied Testing
                      </p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-2293" data-mp="3qgmuylalef6a">
                      <div className="bg-emerald-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-3" data-id="element-2294" data-mp="36vmk24aedjfk">
                        <Users className="text-emerald-600" size={20} data-id="element-2295" data-mp="31y36z7pfrcp7" />
                      </div>
                      <p className="text-center text-sm font-medium text-gray-700" data-id="element-2296" data-mp="3fxvt0pq0p4qu">
                        Clinical Trials
                      </p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-2297" data-mp="3puh0dhpierxu">
                      <div className="bg-amber-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-3" data-id="element-2298" data-mp="3psxmtyv8muzr">
                        <CheckCircle className="text-amber-600" size={20} data-id="element-2299" data-mp="3ffqwrplz4l1" />
                      </div>
                      <p className="text-center text-sm font-medium text-gray-700" data-id="element-2300" data-mp="3ulz2wa76l0kx">
                        Certification
                      </p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-2301" data-mp="ce1b0raqarnx">
                      <div className="bg-purple-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-3" data-id="element-2302" data-mp="7ic4g40akai4">
                        <Globe className="text-purple-600" size={20} data-id="element-2303" data-mp="31atxo3z7c7hn" />
                      </div>
                      <p className="text-center text-sm font-medium text-gray-700" data-id="element-2304" data-mp="368bzlaesxmg5">
                        Global Application
                      </p>
                    </div>
                  </div>
                </div>
                <div className="text-center mt-6" data-id="element-2305" data-mp="3f28kyn056uui">
                  <a href="/contact" className="px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200 shadow-sm inline-flex items-center" data-id="element-2306" data-mp="3jyfhxqak8w0b">
                    Contact Our Research Team
                    <ArrowRight size={16} className="ml-2" data-id="element-2307" data-mp="1u5hn0zzszfe" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-2308" data-mp="23kz3g60kqcvu" />
    </div>;
}